// extracted by mini-css-extract-plugin
module.exports = {"desktopNav":"style__desktopNav__UMsLd"};